"use client";

import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Construction() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const channels = [{
    number: "01",
    title: "General Contracting",
    description: "Comprehensive construction management delivering structural integrity and architectural precision for residential and commercial projects.",
    features: ["Full-scale site management", "Structural framing & masonry", "Custom interior finishing", "Code compliance & safety"],
    href: "\n"
  }, {
    number: "02",
    title: "Property Management",
    description: "Proactive stewardship of your real estate assets, ensuring long-term value through meticulous maintenance and operational oversight.",
    features: ["Preventative maintenance plans", "Tenant coordination services", "Emergency repair response", "Asset performance reporting"],
    href: "/PropertyStewardshipPage"
  }, {
    number: "03",
    title: "Custom Renovations",
    description: "Tailored remodeling solutions that blend modern functionality with the timeless craftsmanship of Moscariello Construction.",
    features: ["Kitchen & bath modernization", "Structural layout optimization", "High-end material sourcing", "Project timeline management"],
    href: "/TheMoscarielloLegacyPage"
  }];
  return <section data-section-id="3998" id="construction-services" className="bg-background text-foreground relative overflow-hidden py-20 md:py-28 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div ref={headerRef} className={`text-center mb-16 md:mb-20 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="h-px w-12 bg-border" />
            <span className="font-mono text-xs tracking-[0.3em] text-primary uppercase">
              The Blueprint — 03 Pillars
            </span>
            <div className="h-px w-12 bg-border" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium text-foreground leading-tight tracking-tight">
            Foundations of excellence.
          </h2>
        </div>

        {}
        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-px bg-border border border-border rounded-lg overflow-hidden transition-all duration-700 ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {channels.map((channel, i) => <div key={i} data-index={i} className="group relative bg-card border border-border md:border-0 hover:border-secondary transition-all duration-500 ease-out p-8 md:p-10 flex flex-col">
              {}
              <div className="mb-6">
                <span className="font-serif text-6xl md:text-7xl font-light text-primary leading-none block">
                  {channel.number}
                </span>
                <div className="mt-2 font-mono text-[10px] tracking-[0.3em] text-muted-foreground uppercase">
                  SEC / {channel.number}
                </div>
              </div>

              {}
              <h3 className="font-serif font-default text-2xl md:text-3xl font-medium text-foreground mb-6 leading-tight">
                {channel.title}
              </h3>

              {}
              <div className="mb-6 flex items-center gap-3">
                <div className="relative w-[50px] h-[50px] rounded-lg border border-border bg-background flex items-center justify-center overflow-hidden">
                  <div className="absolute inset-1 rounded-lg bg-secondary/10" />
                  <div className="absolute bottom-1 left-1/2 -translate-x-1/2 w-px h-7 bg-secondary origin-bottom transition-transform duration-700 ease-out" style={{
                transform: "translateX(-50%) rotate(-35deg)"
              }} />
                  <div className="absolute bottom-1 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-lg bg-secondary" />
                  <div className="absolute top-1.5 left-1.5 w-1 h-1 rounded-lg bg-secondary/60" />
                </div>
                <div className="font-mono text-[10px] tracking-widest text-muted-foreground uppercase">
                  STATUS / ACTIVE
                </div>
              </div>

              {}
              <p className="font-sans text-sm text-muted-foreground leading-relaxed mb-6">
                {channel.description}
              </p>

              {}
              <ul className="space-y-3 mb-8">
                {channel.features.map((feature, fi) => <li data-index={fi} key={fi} className="flex items-start gap-3 font-sans text-sm text-foreground/90">
                    <Check className="size-4 text-secondary mt-0.5 flex-shrink-0" strokeWidth={2.5} />
                    <span>{feature}</span>
                  </li>)}
              </ul>

              {}
              
            </div>)}
        </div>

        {}
        <div ref={footerRef} className={`mt-16 flex items-center justify-center gap-4 md:gap-6 transition-all duration-700 ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="h-px flex-1 max-w-[180px] bg-border" />
          <span className="font-mono text-[11px] md:text-xs tracking-[0.25em] text-muted-foreground uppercase text-center">
            Moscariello Construction &mdash; Collegeville, PA
          </span>
          <div className="h-px flex-1 max-w-[180px] bg-border" />
        </div>
      </div>
    </section>;
}